document.addEventListener('DOMContentLoaded', function() {
    const swatches = document.querySelectorAll('.ul-swatches-list li.swatches-options');

    swatches.forEach((swatch, index) => {
        if(index >= 5) { // agar 5 se zyada ho
            swatch.addEventListener('click', function() {
                const productId = swatch.getAttribute('productid');
                // Shopify ke product page URL structure
                const productPageUrl = `/products/${productId}`; 
                window.location.href = productPageUrl;
            });
        }
    });
});
